import { BookOpen } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Text,
} from '@musa.tech/design-system';

const FAQ_ITEMS = [
  {
    value: 'dados',
    question: 'De onde vêm os dados?',
    answer:
      'Os dados são obtidos a partir dos registros de coleta e destinação final dos resíduos realizados pelas unidades geradoras. Cada coleta é documentada com peso, tipo de material e destino final, garantindo rastreabilidade completa.',
  },
  {
    value: 'calculo',
    question: 'Como o CO₂ mitigado é calculado?',
    answer:
      'O cálculo utiliza fatores de emissão reconhecidos internacionalmente (como os do GHG Protocol e EPA) que estimam a quantidade de CO₂ equivalente que deixou de ser emitido quando um material é reciclado em vez de descartado em aterro. Cada tipo de resíduo possui um fator específico.',
  },
  {
    value: 'fatores',
    question: 'Quais fatores de conversão são usados?',
    answer:
      'Utilizamos fatores de conversão publicados por instituições como EPA (Environmental Protection Agency), GHG Protocol e IPCC. Por exemplo: 1 tonelada de papel reciclado evita aproximadamente 1,8 toneladas de CO₂ equivalente. Uma árvore absorve em média 160 kg de CO₂ por ano.',
  },
  {
    value: 'esg',
    question: 'Posso usar esses dados em relatórios ESG?',
    answer:
      'Sim. Os dados apresentados seguem metodologias reconhecidas e podem ser utilizados em relatórios de sustentabilidade, apresentações ESG e auditorias ambientais. Recomendamos exportar o relatório em PDF para documentação formal.',
  },
];

export const IAFAQ = () => {
  return (
    <div className="rounded-xl border border-border bg-card p-5">
      {/* Cabeçalho */}
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-lg bg-success-500/10 flex items-center justify-center shrink-0">
          <BookOpen className="w-5 h-5 text-success-500" />
        </div>
        <div>
          <Text variant="heading" size="large" className="text-foreground">Como calculamos o impacto?</Text>
          <Text variant="body" size="small" className="text-muted-foreground">
            Transparência sobre a origem e metodologia dos dados
          </Text>
        </div>
      </div>

      {/* Accordion */}
      <Accordion type="single" collapsible className="w-full">
        {FAQ_ITEMS.map((item) => (
          <AccordionItem key={item.value} value={item.value}>
            <AccordionTrigger className="hover:no-underline">
              <Text variant="label" size="small" className="text-foreground">{item.question}</Text>
            </AccordionTrigger>
            <AccordionContent className="leading-relaxed">
              <Text variant="body" size="small" className="text-muted-foreground">{item.answer}</Text>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};
